/**
 * Check, is provided email has generic provider from list
 *
 * @param email
 * @returns {number}
 */
function checkGenericEmail (email) {
    var generics_filtered = [];

    if (email && email.split('@')[1]) {
        var static_generics_emails = [
            '@gmail.',
            '@mac.',
            '@yahoo.',
            '@hotmail.',
            '@sbcglobal.',
            '@earthlink.',
            '@att.',
            '@aol.',
            '@comcast.',
            '@me.',
            '@ymail.',
            '@googlemail.',
            '@163.',
            '@msn.',
            '@rocketmail.',
            '@bellsouth.',
            '@cox.',
            '@live.',
            '@100m.hl.cninfo.net',
            '@123india.com',
            '@126.com',
            '@12move.nl',
            '@163.com',
            '@163.net',
            '@169.cc',
            '@188.net',
            '@188mail.com',
            '@2000net.com',
            '@21cn.com',
            '@24horas.com',
            '@2911.net',
            '@2bmail.co.uk',
            '@2bsure.com',
            '@2ndmail.com',
            '@2rd.net',
            '@2xs.net',
            '@363.net',
            '@371.net',
            '@39.net',
            '@3web.net',
            '@777.net.cn',
            '@8848.net',
            '@888.nu',
            '@88998.com',
            '@8d8d.com',
            '@909mail.dk',
            '@990.net',
            '@a4.no',
            '@aaronkwok.net',
            '@abcflash.net',
            '@abv.bg',
            '@adres.nl',
            '@advalvas.be',
            '@ahmedabad.net',
            '@albawaba.com',
            '@alinto.com',
            '@all.bg',
            '@allesklar.de',
            '@altavista.co.kr',
            '@altavista.co.uk',
            '@altavista.de',
            '@altavista.nl',
            '@altavista.se',
            '@alwaysbeconnected.com',
            '@amuro.net',
            '@anjungcafe.com',
            '@another.com',
            '@anyemail.net',
            '@aol.co.uk',
            '@aol.com',
            '@apenstaartje.com',
            '@apexmail.com',
            '@a-po.st',
            '@apollo.lv',
            '@ar.yahoo.com',
            '@arabia.com',
            '@arealcity.com',
            '@arsenal.co.uk',
            '@artic.net',
            '@asiafind.com',
            '@asiafind.com',
            '@asiafind.com',
            '@asia-links.com',
            '@asia-links.com',
            '@asia-links.com',
            '@asiancityweb.com',
            '@asiancityweb.com',
            '@asiancityweb.com',
            '@asianhome.net',
            '@asianhome.net',
            '@asiaone.com.sg',
            '@ask.co.uk',
            '@astaga.com',
            '@asturies.com',
            '@a-topmail.at',
            '@atozasia.com',
            '@aucland.es',
            '@aude.org',
            '@aufeminin.com',
            '@ausi.com',
            '@aussiemail.com.au',
            '@australia.edu',
            '@australianmalls.com',
            '@autonr.net',
            '@axis.org',
            '@axn-asia.com',
            '@b73.de',
            '@balitribune.com',
            '@bangladesh.net',
            '@bantu.com',
            '@basemail.com.br',
            '@beep.ru',
            '@belgique.com',
            '@belgrade.co.yu',
            '@Bellsouth.net',
            '@bentium.net',
            '@beograd.com',
            '@berlin.de',
            '@bigfoot.de',
            '@bigfot.de',
            '@bimamail.com',
            '@bip.net',
            '@bkkmail.com',
            '@blackbox.net',
            '@blackburnmail.com',
            '@bluemail.ch',
            '@bluemail.dk',
            '@bmypc.com',
            '@bnp-mail.com',
            '@bnp-mail.com',
            '@bogota.com',
            '@boitolet.com',
            '@boitolet.com',
            '@bol.com.br',
            '@bolehmail.com',
            '@bosnianmail.com',
            '@brasilia.net',
            '@brestonline.com',
            '@britishvirginislands.com',
            '@broadcastindia.com',
            '@burek.net',
            '@burgerking.de',
            '@businessnet.de',
            '@byte.it',
            '@cabana.net',
            '@canada-11.com',
            '@canadasown.net',
            '@canoe.ca',
            '@caramail.com',
            '@cari.com.my',
            '@caryon.com',
            '@ccnt.com.cn',
            '@centras.lt',
            '@centrum.cz',
            '@chaitime.com',
            '@channelnewsasia.com',
            '@Charter.net',
            '@chat.ru',
            '@check1check.com',
            '@chequemail.com',
            '@cheshiremail.com',
            '@chez.com',
            '@china.com',
            '@chinaarmy.net',
            '@chinabyte.com',
            '@chinahot.net',
            '@chinaice.com',
            '@chinanew.com',
            '@chinaren.com',
            '@chinese.com',
            '@chinese.net.my',
            '@chinese88.com',
            '@chinesemail.org',
            '@ciaoweb.it',
            '@citeweb.net',
            '@cityhot.com',
            '@citymail.net.nz',
            '@citynet.co.kr',
            '@ciudad.com.ar',
            '@claramail.com',
            '@click2asia.com',
            '@click2asia.com',
            '@click2asia.com',
            '@clickfish.com',
            '@club.lemonde.fr',
            '@cmmail.com',
            '@cn.joymail.com',
            '@cncou.com',
            '@cnnb.net',
            '@Comcast.net',
            '@community.s-one.net.sg',
            '@communityconnect.com',
            '@communityconnect.com',
            '@communityconnect.com',
            '@computerchannel.de',
            '@connectfree.co.uk',
            '@coolmail.ch',
            '@copacabana.com',
            '@coqualane.ch',
            '@core.lv',
            '@correio.com',
            '@correo.nu',
            '@correoweb.com',
            '@courrier.id-clic.com',
            '@courrier.remcomp.fr',
            '@courrier.yahoo.fr',
            '@Cox.net',
            '@csucs.hu',
            '@ctinets.com',
            '@ctn.com.cn',
            '@cumbriamail.com',
            '@curio-city.com',
            '@cxp.com.br',
            '@cyberdif.com',
            '@cyberinbox.com',
            '@cybernet.in.th',
            '@daum.net',
            '@dbzmail.com',
            '@dds.nl',
            '@de.lycosmail.com',
            '@decajon.com',
            '@delfi.lv',
            '@detik.com',
            '@deutschland.youpy.com',
            '@digibel.be',
            '@digitalmail.com',
            '@diktator.de',
            '@dindas.de',
            '@dl163.com',
            '@dolfijn.nl',
            '@domain.com.tw',
            '@doramail.com',
            '@downsouth.co.uk',
            '@dragonsurf.com',
            '@dreamer.com.cn',
            '@dreamer.com.tw',
            '@drotposta.hu',
            '@durschti.net',
            '@duse.net',
            '@earth9.com',
            '@Earthlink.net',
            '@eastciti.com',
            '@eastday.com.cn',
            '@eastmail.com',
            '@easypost.com',
            '@eazier.com',
            '@ecosse.net',
            '@ecuamail.com.ec',
            '@ecuamail.com.ec',
            '@edsamail.com.ph',
            '@efes.net.tr',
            '@egon.gyaloglo.hu',
            '@eguo.com',
            '@egyptsun.com',
            '@ehmail.com',
            '@eindia.com',
            '@einkaufzentrum.de',
            '@einsundeins.de',
            '@ekilat.com',
            '@elong.com',
            '@em365.com',
            '@e-mail.co.kr',
            '@email.co.yu',
            '@email.com.cn',
            '@email.cz',
            '@email.de',
            '@email.ireland.com',
            '@email.is',
            '@email.itl.net.ua',
            '@e-mail.ru',
            '@email.seznam.cz',
            '@email.si',
            '@emaila.nu',
            '@emailgaul.com',
            '@emailnow.com.au',
            '@emailnow.com.au',
            '@emailpinoy.com',
            '@emailplanet.com',
            '@emailplanet.com',
            '@emailplanet.com',
            '@emailplanet.com',
            '@emailplanet.com',
            '@emailplanet.com',
            '@emailpostbox.com',
            '@enelpunto.net',
            '@ennepetal.com',
            '@enter.vg',
            '@enzoy.com',
            '@eon.dk',
            '@epost.de',
            '@e-post.lt',
            '@es.lycosmail.com',
            '@espana.youpy.com',
            '@eszett.de',
            '@etang.com',
            '@everyday.com',
            '@everyday.com',
            '@everymail.net',
            '@everyroad.net',
            '@excite.ca',
            '@excite.com',
            '@excite.com.au',
            '@excite.es',
            '@excite.it',
            '@exit.de',
            '@extended.de',
            '@eyah.com.au',
            '@eyou.com',
            '@ez.info.com.ph',
            '@fast.rh.com.pe',
            '@fastmail.ca',
            '@fastmail.com',
            '@fcbayern.de',
            '@fcukmail.com',
            '@fetchmail.co.uk',
            '@ffnfuncity.de',
            '@firemail.de',
            '@flairmail.com',
            '@flytecrew.com',
            '@fm365.com',
            '@fr.bigfoot.com',
            '@fr.lycosmail.com',
            '@france-mail.com',
            '@free.fr',
            '@free.net.nz',
            '@free.polbox.pl',
            '@free.tri.at',
            '@free.xtel.com',
            '@free-hosting.lt',
            '@freemail.c3.hu',
            '@freemail.co.za',
            '@freemail.codec.ro',
            '@freemail.com.au',
            '@freemail.com.pk',
            '@freemail.fx.ro',
            '@freemail.goo.ne.jp',
            '@freemail.gr',
            '@freemail.it',
            '@freemail.ncs.net.hk',
            '@freemail.nl',
            '@freemail.org.mk',
            '@freemail.ru',
            '@free-online.net',
            '@freeweb.aspide.it',
            '@freeweb.essenet.it',
            '@freshmail.de',
            '@friko.internet.pl',
            '@friko.internet.pl',
            '@fronttraining.com',
            '@fsf.com.au',
            '@ft.com',
            '@funkytiger.co.uk',
            '@funmail.co.uk',
            '@future-online.net',
            '@fz.ml.org',
            '@gala.net',
            '@gate99.nl',
            '@gauch.ch',
            '@gaza.net',
            '@gedris.org',
            '@germanmail.com',
            '@germany.net',
            '@gigileung.org',
            '@glay.org',
            '@glormhaigheo.com',
            '@gmail.co.uk',
            '@gmail.com',
            '@gmx.net',
            '@goaworld.com',
            '@gocolchester.com',
            '@gohdirect.com',
            '@gomail.com.ua',
            '@gopinoy.com',
            '@grabmail.com',
            '@graffiti.net',
            '@gravity.net.au',
            '@grooveasia.com',
            '@grooveasia.com',
            '@grooveasia.com',
            '@gsel.com',
            '@guay.com',
            '@guil.eu.org',
            '@guju.net',
            '@gwapo.com',
            '@gzyp21.net',
            '@halee.com',
            '@halyava.ru',
            '@heike.net',
            '@helloasia.com',
            '@helloasia.com',
            '@helloasia.com',
            '@hikyaku.com',
            '@hk.joymail.com',
            '@hkem.com',
            '@hkepost.com',
            '@hkgx.com',
            '@hkid.com',
            '@hkmail.net',
            '@hkonly.com',
            '@hkwire.com',
            '@hl.cninfo.net',
            '@home.co.yu',
            '@home.se',
            '@home.sina.com',
            '@home.sina.com.cn',
            '@home.sina.com.hk',
            '@homeway.com.cn',
            '@hongen.com.cn',
            '@hongkong.com',
            '@hooger.ch',
            '@hotmail.co.il',
            '@hotmail.co.jp',
            '@Hotmail.co.jp',
            '@hotmail.co.th',
            '@hotmail.co.uk',
            '@Hotmail.co.uk',
            '@hotmail.com',
            '@hotmail.com',
            '@hotmail.com.ar',
            '@hotmail.com.br',
            '@hotmail.com.tr',
            '@hotmail.de',
            '@hotmail.es',
            '@hotmail.fr',
            '@hotmail.it',
            '@hotmail.jp',
            '@hotmail.se',
            '@hrvatskamail.com',
            '@humour.com',
            '@hurra.de',
            '@iboom.com',
            '@ice.is',
            '@ieg.com.br',
            '@ifrance.com',
            '@ilovehk.com',
            '@iloveindia.com',
            '@i-mail.com.au',
            '@immk.net',
            '@inbox.com.pk',
            '@inbox.lv',
            '@india.com',
            '@india-11.com',
            '@indiainfo.com',
            '@indiaseek.com',
            '@indiasite.com',
            '@indiatimes.com',
            '@indo-mail.com',
            '@infojobs.es',
            '@infoworld.sh.cn',
            '@inmail.sk',
            '@instuttgart.de',
            '@intellect.com.tw',
            '@interia.pl',
            '@inwind.it',
            '@iobox.de',
            '@iobox.fi',
            '@iobox.se',
            '@iol.it',
            '@iqiq.net',
            '@irish4ever.com',
            '@irol.net',
            '@iskon.hr',
            '@ismart.com.hk',
            '@issihk.net',
            '@it.lycosmail.com',
            '@italia.youpy.com',
            '@iupi.pt',
            '@jaydemail.com',
            '@jmail.co.jp',
            '@joongang.co.kr',
            '@jordan-net.de',
            '@jpopmail.com',
            '@jubii.dk',
            '@jumpy.it',
            '@juntos.com',
            '@juridica.com',
            '@juventusmail.net',
            '@kali.com.cn',
            '@kantone.net',
            '@kataweb.it',
            '@kellychen.com',
            '@kennzeichen.net',
            '@keromail.com',
            '@keyciti.com.tw',
            '@kichimail.com',
            '@kingnet.com.tw',
            '@kittymail.com',
            '@kittymail.com',
            '@kitznet.at',
            '@kki.net.pl',
            '@km169.net',
            '@kmail.com.au',
            '@korea.com',
            '@koreanmail.com',
            '@kschoice.net',
            '@kurir.net',
            '@kzinfo.net',
            '@ladymail.cz',
            '@lakmail.com',
            '@la-mano.com',
            '@lancsmail.com',
            '@lanetro.com',
            '@latinmail.com',
            '@latinsite.com',
            '@latinsite.com',
            '@lc1.law5.hotmail.passport.com',
            '@lemailparisien.com',
            '@leonlai.net',
            '@lettera.net',
            '@letterbox.com',
            '@letterindia.com',
            '@lexpress.net',
            '@libanismail.com',
            '@libemail.com',
            '@libero.iol.it',
            '@linomail.de',
            '@linuxmail.org',
            '@liquidinformation.net',
            '@live.at',
            '@live.be',
            '@live.ca',
            '@live.cl',
            '@live.cn',
            '@live.co.kr',
            '@live.co.za',
            '@live.com',
            '@live.com.ar',
            '@live.com.au',
            '@live.com.mx',
            '@live.com.my',
            '@live.com.sg',
            '@live.de',
            '@live.dk',
            '@live.fr',
            '@live.hk',
            '@live.ie',
            '@live.in',
            '@live.it',
            '@live.jp',
            '@live.nl',
            '@live.no',
            '@live.ru',
            '@live.se',
            '@liveclub.co.uk',
            '@locos.com',
            '@login.virtualjerusalem.com',
            '@loja.net',
            '@looksmart.co.uk',
            '@looksmart.com.au',
            '@lottos.com.au',
            '@lovecat.com',
            '@luso.pt',
            '@luukku.com',
            '@lycosbox.com',
            '@lycosbox.com',
            '@mail.168city.com',
            '@mail.2friend.com',
            '@mail.alibaba.com',
            '@mail.amei.cc',
            '@mail.asiapoint.net',
            '@mail.asiapoint.net',
            '@mail.asiapoint.net',
            '@mail.atlas.cz',
            '@mail.az',
            '@mail.bangkok.com',
            '@mail.bg',
            '@mail.bta.net.cn',
            '@mail.catcha.com',
            '@mail.chek.com',
            '@mail.chek.com',
            '@mail.co-co.cc',
            '@mail.com',
            '@mail.cz',
            '@mail.digiro.net',
            '@mail.dotcom.fr',
            '@mail.ee',
            '@mail.euroseek.net',
            '@mail.euroseek.net',
            '@mail.excite.co.jp',
            '@mail.excite.co.uk',
            '@mail.excite.de',
            '@mail.forum.dk',
            '@mail.fotofutura.com',
            '@mail.freenation.net',
            '@mail.gnetpri.com',
            '@mail.gr',
            '@mail.hkmag.com',
            '@mail.home.ro:81',
            '@mail.hutchcity.com',
            '@mail.kitty.cc',
            '@mail.kstop.co.kr',
            '@mail.latino.com',
            '@mail.lv',
            '@mail.lycos.co.kr',
            '@mail.lycos.com',
            '@mail.md',
            '@mail.naseej.com',
            '@mail.od.ua',
            '@mail.on.com.tw',
            '@mail.otelo-online.de',
            '@mail.pchome.com.tw',
            '@mail.pt',
            '@mail.ru',
            '@mail.seguros.com.br',
            '@mail.teddy.cc',
            '@mail.telkom.net',
            '@mail.tjohoo.se',
            '@mail.tonghua.com.cn',
            '@mail.tuner.fm',
            '@mail.unicum.de',
            '@mail.voila.fr',
            '@mail.webcity.ca',
            '@mail.x-stream.co.uk',
            '@mail.yahoo.ca',
            '@mail.yahoo.co.nz',
            '@mail.yahoo.com.au',
            '@mail.yahoo.com.br',
            '@mail.yahoo.com.mx',
            '@mail.yahoo.de',
            '@mail.yahoo.dk',
            '@mail.yahoo.ie',
            '@mail.yahoo.it',
            '@mail.yahoo.no',
            '@mail.yahoo.se',
            '@mail2000.com.tw',
            '@mail2india.com',
            '@mail2web.com',
            '@mail4u.nl',
            '@mail4you.de',
            '@mailasia.com',
            '@mailasia.com',
            '@mailasia.com',
            '@mailbank.ne.jp',
            '@mailbox.gr',
            '@mailbox.sk',
            '@mailbr.com.br',
            '@mailcity.lycos.co.jp',
            '@mailcityasia.lycos.com',
            '@mailclub.net',
            '@mailinator.com',
            '@mailit.com.au',
            '@mailje.nl',
            '@mailme.dk',
            '@mailmij.nl',
            '@mailnova.com',
            '@mail-online.dk',
            '@mailpanda.com',
            '@mailperso.com',
            '@mailreader.com',
            '@mails.ch',
            '@mails.hu',
            '@mailstart.com',
            '@mailstart.com',
            '@mailstart.com',
            '@mailthat.net',
            '@mailto.it',
            '@mailtw.com',
            '@maktoob.com',
            '@manager.de',
            '@mancity.net',
            '@manufree.net',
            '@marca.es',
            '@marchmail.com',
            '@marketing.lu',
            '@marketing.lu',
            '@markguide.com',
            '@martignan.com',
            '@mbox.com.au',
            '@mcrmail.com',
            '@mediaport.nl',
            '@medic.net.au',
            '@mediomail.com',
            '@megacity.com',
            '@megamail.pt',
            '@meloo.com',
            '@mensagem.cc',
            '@merseymail.com',
            '@mexico.com',
            '@mfinance.com',
            '@mfn.de',
            '@mighty.co.za',
            '@mixmail.com',
            '@mobemail.com.au',
            '@mol.com.cn',
            '@mol.mn',
            '@moncourrier.com',
            '@montecafe.com',
            '@montevideo.com.uy',
            '@msgbox.com',
            '@msn.com',
            '@msnhotmail.com',
            '@muder.net',
            '@multimania.fr',
            '@musikinfos.de',
            '@muzi.com',
            '@mweb.com.cn',
            '@mweb.com.cn',
            '@myanmars.net',
            '@mycity.com.cn',
            '@mygale.org',
            '@mymail.co.uk',
            '@mymail.com.au',
            '@mymail.ph',
            '@mypcera.com',
            '@myrice.com',
            '@myweb.de',
            '@nameplanet.com',
            '@nameplanet.com',
            '@nana.co.il',
            '@nederlands.com',
            '@netcityhk.com',
            '@netcrawler.com.pk',
            '@netian.com',
            '@netking.com',
            '@netlords.de',
            '@netmail.nl',
            '@netnet.com.sg',
            '@netposta.net',
            '@netpostbus.com',
            '@netvigator.ca',
            '@netvigator.com',
            '@netvigator.com.my',
            '@netvigator.com.tw',
            '@newmail.net',
            '@newmail.ru',
            '@nexus.hu',
            '@nexxmail.com',
            '@ningbo.net',
            '@nl.lycosmail.com',
            '@nmonline.com.cn',
            '@nomade.fr',
            '@norgesmail.com',
            '@norikomail.com',
            '@nz11.com',
            '@nzemail.co.nz',
            '@o2.pl',
            '@obsidiana.com',
            '@obsidiana.com.ar',
            '@obsidiana.com.ar',
            '@ofir.dk',
            '@oktw.net',
            '@olemail.com',
            '@onet.pl',
            '@online.ie',
            '@online.ie',
            '@online.no',
            '@online.sh.cn',
            '@online.tj.cn',
            '@online-today.de',
            '@operamail.com',
            '@organizer.net',
            '@otakumail.com',
            '@ourchina.net',
            '@outblaze.net',
            '@outgun.com',
            '@overcmail.de',
            '@ownmail.com',
            '@oznetwork.com.au',
            '@pagefrance.com',
            '@pajek.net',
            '@pakcenter.com',
            '@paki.com',
            '@pakistanmail.com',
            '@pakistans.com',
            '@pancevo.com',
            '@paracompra.com',
            '@paramas.com',
            '@passagen.se',
            '@pattayacitythailand.com',
            '@pcmail.com.tw',
            '@pearl-online.de',
            '@peoplemail.com.cn',
            '@personales.com',
            '@perthmail.com.',
            '@peru.com',
            '@philippines.to',
            '@phokat.com',
            '@pimail.be',
            '@pimail.com.pk',
            '@pinoymail.com',
            '@planet2000.de',
            '@planet-online.de',
            '@planet-samoa.com',
            '@plasa.com',
            '@pobox.sk',
            '@pochtamt.ru',
            '@poczta.fm',
            '@pokefan.com',
            '@pokemon.com.my',
            '@popaccount.com',
            '@popaccount.com',
            '@popsmail.com',
            '@portalen.no',
            '@portugalmail.pt',
            '@post.cz',
            '@post.de',
            '@post.sk',
            '@postaweb.com',
            '@postmanpat.org.uk',
            '@postmaster.co.uk',
            '@prim.hu',
            '@privacyx.com',
            '@privat.web-art.de',
            '@prontomail.ne.jp',
            '@proudcanadian.net',
            '@proudindians.com',
            '@purpleturtle.com',
            '@qmail.cz',
            '@rad-dresden.de',
            '@rdsnet.ro',
            '@Rediffmail.com',
            '@rediffmail.com',
            '@redom.edu.do',
            '@reflex.at',
            '@regards.net',
            '@renren.com',
            '@renren.com',
            '@repsol.com',
            '@respublica.fr',
            '@rexian.com',
            '@rileks.com',
            '@rinderwahnsinn.de',
            '@robotmail.ne.jp',
            '@rocketmail.com',
            '@rsprog.co.yu',
            '@rtl-online.de',
            '@sammimail.com',
            '@sanriotown.com',
            '@sarmail.com',
            '@satyamonline.com',
            '@schlingel.de',
            '@schweiz.ch',
            '@sd1.de',
            '@searcheuropemail.com',
            '@searcheuropemail.com',
            '@searcheuropemail.com',
            '@searcheuropemail.com',
            '@seedcity.com',
            '@serbiancity.com',
            '@seudominio.com.br',
            '@Shaw.ca',
            '@shikong.com',
            '@siammail.com',
            '@siliconbd.com',
            '@sina.com.tw',
            '@singmail.com',
            '@sites-internet.com',
            '@siutao.com',
            '@ski.com.au',
            '@skydiver.de',
            '@slartibartfast.pp.se',
            '@slo.net',
            '@slomail.com',
            '@slovenia-cafe.com',
            '@smapxsmap.net',
            '@smartvia.de',
            '@sobao.com',
            '@sofcom.com.au',
            '@sohu.com.cn',
            '@soim.net',
            '@soyou.com',
            '@sportasia.com',
            '@sportbarrio.com',
            '@spray.fr',
            '@spray.it',
            '@spray.net',
            '@spray.no',
            '@spray.se',
            '@starmate.com',
            '@starmedia.com',
            '@starmedia.com',
            '@starmedia.com',
            '@starmedia.com',
            '@start.com.au',
            '@start.no',
            '@sternpost.de',
            '@stetic.net',
            '@student.be',
            '@stutensee.net',
            '@subotica.com',
            '@sunpoint.net',
            '@surabayacity.com',
            '@surflondon.co.uk',
            '@surftimemag.com',
            '@surfway.de',
            '@sverige.nu',
            '@sy163.net',
            '@t2mail.com',
            '@taipeilink.net',
            '@taiwan.com',
            '@taiwandot.com',
            '@takas.lt',
            '@talk21.com',
            '@tantriks.com',
            '@telekbird.com.cn',
            '@terra.cl',
            '@terra.com',
            '@terra.com.ar',
            '@terra.com.co',
            '@terra.com.do',
            '@terra.com.do',
            '@terra.com.gt',
            '@terra.com.mx',
            '@terra.com.pa',
            '@terra.com.pe',
            '@terra.com.sv',
            '@terra.com.uy',
            '@terra.com.ve',
            '@terra.es',
            '@tesco.net',
            '@tf1.fr',
            '@thai.com',
            '@thaimail.com',
            '@thaimail.org',
            '@thaiservice.com',
            '@thatweb.com',
            '@themail.co.uk',
            '@timormail.com',
            '@tintin.org',
            '@today.com.au',
            '@tokyo24.com',
            '@tokyo24.com',
            '@tollon.co.uk',
            '@tom.com',
            '@tomcat.ru',
            '@topmail.co.uk',
            '@topmail.de',
            '@torget.se',
            '@toschi.de',
            '@tpemail.net.tw',
            '@tropicmail.com',
            '@tur.net',
            '@turbomail.net',
            '@turkiye.tc',
            '@tut.by',
            '@tutopia.com',
            '@tutoriais.com',
            '@tvnet.lt',
            '@tvnet.lv',
            '@tw.joymail.com',
            '@ucs.com.tw',
            '@uk.bigfoot.com',
            '@uk111.com',
            '@uk2.net',
            '@ukmax.com',
            '@ukr.net',
            '@ukrpost.net',
            '@unete.com',
            '@uni.de',
            '@unistudent.com.au',
            '@uol.com.br',
            '@uolmail.com',
            '@uolmail.com.ar',
            '@uolmail.com.co',
            '@uolmail.com.mx',
            '@uolmail.com.ve',
            '@up-to.net',
            '@url.com.tw',
            '@uymail.com',
            '@Verizon.net',
            '@verpiss-dich.de',
            '@verywoman.net',
            '@vietnammail.net',
            '@vip.gr',
            '@virgilio.it',
            '@virtualindia.com',
            '@visitmail.com',
            '@vol.vnn.vn',
            '@w3-graphixx.de',
            '@walla.co.il',
            '@wappi.com',
            '@waumail.com',
            '@wawasan2020.com',
            '@wbox.de',
            '@web-culture.com',
            '@webinfo.fi',
            '@webmail.co.yu',
            '@webmail.co.za',
            '@webmail.laposte.net',
            '@webmail.net.nz',
            '@webmail.ozbytes.net.au',
            '@webmail.sapo.pt',
            '@webmail.shinbiro.com',
            '@webmail.telstra.com',
            '@webmail.vnn.vn',
            '@webstar.com.my',
            '@westmail.net',
            '@windoms.sitek.net',
            '@windygates.co.uk',
            '@winmail.net',
            '@wireworm.com',
            '@wish.nl',
            '@wlf.de',
            '@wocall.com.cn',
            '@wonet.com',
            '@woodo.com.tw',
            '@world4fun.ch',
            '@worldatlas.com.sg',
            '@worldmexico.com',
            '@worldwidemail.co.uk',
            '@wp.pl',
            '@wprost.pl',
            '@www1.5415.com',
            '@www2.altnews.com.au',
            '@wx88.net',
            '@x9media.de',
            '@xd990.net',
            '@Yahoo.ca',
            '@yahoo.co.hk',
            '@Yahoo.co.in',
            '@yahoo.co.in',
            '@Yahoo.co.jp',
            '@yahoo.co.jp',
            '@yahoo.co.kr',
            '@yahoo.co.uk',
            '@yahoo.com',
            '@yahoo.com.cn',
            '@yahoo.com.sg',
            '@yahoo.com.tw',
            '@yam.com.tw',
            '@yandex.ru',
            '@yap.com.au',
            '@yawmail.com',
            '@yehey.com',
            '@yesbox.net',
            '@yifan.com',
            '@yo-mail.de',
            '@youpy.ch',
            '@youpy.co.uk',
            '@youpy.com',
            '@youpy.com',
            '@youpy.fr',
            '@yourmail.com.au',
            '@yoyo.pl',
            '@yp.com.mo',
            '@yupi.com',
            '@yyhmail.com',
            '@zahav.net.il',
            '@zaobao.com.sg',
            '@zdnetmail.ne.jp',
            '@zhaodaola.com.cn',
            '@ziplip.co.jp',
            '@zipmail.co.nz',
            '@zipmail.com.br',
            '@zmail.to',
            '@zonnet.nl',
            '@zworg.com',
            '@outlook.com',
            '@icloud.com',
        ];
        var generics_emails = window.generics_emails || static_generics_emails;
        var domain = '@' + email.split('@')[1];

        generics_emails.forEach(function (generic) {
            var regexp = new RegExp('^' + generic.replace('.', '\\.') + '(.*)$');
            if (regexp.test(domain)) {
                generics_filtered.push(domain);
            }
        });
    }

    return generics_filtered.length;
}

window.formsValidateEmail = window.formsValidateEmail || [1044, 1833, 1895, 1837, 1089, 1193];
window.formsValidateEmailTooltip = window.formsValidateEmailTooltip || [1044, 1833, 1895, 1837, 1089, 1193, 1380, 1002, 1872, 2025, 2097, 2127, 1936, 1830, 2074, 2129, 1888, 2085];
window.is_contact_sales_page = (jQuery('.contact-page--sales').length > 0);
window.is_contact_demo_page_generic = (jQuery('.contact-page--get-demo').length > 0);

window.is_work_email_validation_page = function(){
    var is_demo = false;
    for (var i = 0, len = window.formsValidateEmail.length; i < len; i++) {
        if(jQuery('#mktoForm_' + window.formsValidateEmail[i] ).length){
            is_demo = true;
        }
    }
    return is_demo;
};

window.is_work_email_tooltip_page = function(){
    var is_demo = false;
    for (var i = 0, len = window.formsValidateEmailTooltip.length; i < len; i++) {
        if(jQuery('#mktoForm_' + window.formsValidateEmailTooltip[i] ).length){
            is_demo = true;
        }
    }
    return is_demo;
};

window.is_work_email_tooltip = function(formId){
    return typeof window.formsValidateEmailTooltip !== 'undefined'
        && window.formsValidateEmailTooltip.length > 0
        && window.formsValidateEmailTooltip.indexOf(formId) !== -1;
}

window.is_work_email_validation = function(formId){
    return typeof window.formsValidateEmail !== 'undefined'
        && window.formsValidateEmail.length > 0
        && window.formsValidateEmail.indexOf(formId) !== -1;
}

window.formsValidatePhone = window.formsValidatePhone || [];
window.is_form_phone_validation = function(formId){
    return typeof window.formsValidatePhone !== 'undefined'
        && window.formsValidatePhone.length > 0
        && window.formsValidatePhone.indexOf(formId) !== -1;
}

if (typeof MktoForms2 !== 'undefined') {
    MktoForms2.whenReady(function (form) {
        String.prototype.capitalize = function(){
            return this.replace( /(^|s)([a-z])/g , function(m,p1,p2){ return p1+p2.toUpperCase(); } );
        };
        var formElement = form.getFormElem();
        /////////////////
        // Form Phone Init
        if(window.is_contact_sales_page || window.is_contact_demo_page_generic || formElement.hasClass('validate-phone') || window.is_form_phone_validation(form.getId())) {
            var phoneField = formElement.find('#Phone');
            if(phoneField.length) {
                var phoneFieldPlaceholder = phoneField.attr('placeholder') ? phoneField.attr('placeholder') : '';
                var phonePrefix = 'e.g.', phoneTranslation = 'Phone';

                if(typeof window.marketo_translations !== 'undefined'){
                    [phoneFieldPlaceholder, phonePrefix, phoneTranslation] = [phoneFieldPlaceholder, phonePrefix, phoneTranslation].map(function(key){
                        if(typeof window.marketo_translations[key] !== 'undefined') {
                            return window.marketo_translations[key];
                        } else {
                            return key;
                        }
                    });
                }

                form.phoneIntNumber = window.intlTelInput(phoneField[0], {
                    autoPlaceholder: 'aggressive',
                    separateDialCode: true,
                    nationalMode: true,
                    preferredCountries: ['us', 'gb', 'ca', 'au', 'fr', 'de', 'es'],
                    initialCountry: "auto",
                    geoIpLookup: function(success, failure) {
                        jQuery.get("https://pro.ip-api.com/json/?key=FM9AFzrlSrmN6dr", function() {}, "jsonp").always(function(resp) {
                            var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
                            success(countryCode);
                        });
                    },
                    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                        if(window.innerWidth >= 760) {
                            if(phoneFieldPlaceholder.length) {
                                return phoneFieldPlaceholder + " (" + phonePrefix + " " + selectedCountryPlaceholder + ")";
                            } else {
                                return phonePrefix + " " + selectedCountryPlaceholder;
                            }
                        } else {
                            return  phoneTranslation + " " + phonePrefix + " " + selectedCountryPlaceholder;
                        }
                    },
                });
            }
        }

        if(formElement.find('[name="Country"], [name="Country__c_contact"], [name="State__c_contact"]').length) {
            jQuery.get("https://pro.ip-api.com/json/?key=FM9AFzrlSrmN6dr", function(resp) {
                var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
                var regionName = (resp && resp.regionName) ? resp.regionName : "";
                form.setValues({Country__c_contact :countryCode});
                form.setValues({Country :countryCode});
                form.setValues({State__c_contact :regionName});
            }, "json");
        }

        form.onSubmit(function () {
            var values = form.vals();
            if(values.hasOwnProperty('completeName')) {
                var fullName = values.completeName.trim();

                var first = fullName.split(' ').length > 1
                    ? fullName.split(' ').slice(0, -1).join(' ')
                    : fullName;
                var last = fullName.split(' ').length > 1
                    ? fullName.split(' ').slice(-1).join(' ')
                    : 'null';

                form.vals({
                    'FirstName': first,
                    'LastName': last
                });
            }

            if(values.hasOwnProperty('Phone') && typeof form.phoneIntNumber !== 'undefined' && form.phoneIntNumber.isValidNumber()) {
                form.vals({
                    'Phone': form.phoneIntNumber.getNumber()
                });
            }
            return false;
        });

        form.onValidate(function (validationResult) {
            if(validationResult) {
                var vals = form.vals();
                var isGeneric = window.is_work_email_validation(form.getId()) && checkGenericEmail(vals.Email);

                if (typeof form.phoneIntNumber !== 'undefined' && !form.phoneIntNumber.isValidNumber()) {
                    form.submittable(false);
                    var phoneField = form.getFormElem().find("#Phone");
                    form.showErrorMessage("Please provide valid phone number", phoneField);
                } else if (isGeneric) {
                    form.submittable(false);
                    var emailField = form.getFormElem().find("#Email");
                    form.showErrorMessage(window.message_validation_workemail, emailField);
                } else {
                    form.submittable(true);
                }
            }
        });

        form.onSuccess(function () {
            window.localStorage.setItem('marketo_form_submit_id', form.getId());
            window.localStorage.setItem('marketo_form_submit_valid', Date.now());
        });

        formElement.addClass('mktoForm--styled');
        formElement.find('.mktoField').each(function () {
            var el = jQuery(this),
                parent = el.parents('.mktoFormRow'),
                type = false;

            if(el.is('input')){
                if(el.attr('type') === 'text' || el.attr('type') === 'email' || el.attr('type') === 'tel') {
                    type = 'input';
                }
                if(el.attr('type') === 'checkbox') {
                    type = 'checkbox';
                }
                if(el.attr('type') === 'radio') {
                    type = 'radio';
                }
            }

            if(el.is('select')){
                type = 'select';
            }
            if(type){
                parent.addClass('mktoField--'+type);
            }
            if(el.is('[multiple]')){
                el.attr("size", el.find('option').length);
                parent.addClass('mktoField--multiple');
            }
            if(formElement.find('.mktoPlaceholder').length) {
                formElement.addClass('mktoForm--conditionals');
            }
            formElement.find('.mktoPlaceholder').each(function () {
                jQuery(this).parents('.mktoFormRow').addClass('has-placeholder');
            });
            if(el.is('input') && el.attr('type') === 'email') {
                /**
                 * Change notification state,
                 */
                el[0].addEventListener('keyup', function (e) {
                    var isGeneric = window.is_work_email_tooltip(form.getId()) && checkGenericEmail(e.target.value);
                    var messageEl = el[0].parentNode.querySelector('.mktoEmailFieldMessage') || null;

                    if (isGeneric) {
                        if (!messageEl) {
                            var message = document.createElement('div');
                            message.innerHTML = window.message_validation_workemail;
                            message.classList.add('mktoEmailFieldMessage');
                            el[0].parentNode.appendChild(message);
                        }
                    } else {
                        if (messageEl) {
                            messageEl.remove();
                        }
                    }
                });
            }
        });

        /**
         * Replace string content in the provided NodeElement
         *
         * @param el
         */
        var replaceEntries = function (el) {
            if (el.childNodes.length > 0) {
                el.childNodes.forEach(function (node) {
                    if (node.nodeType === Node.TEXT_NODE) {
                        var key = node.data.trim();
                        var val = window.marketo_translations[key] || null;

                        if( key.indexOf('Welcome back,') !== -1 && window.marketo_translations['Welcome back,'] !== undefined ) {
                            val = key.replace('Welcome back,', window.marketo_translations['Welcome back,']);
                        }

                        if (val !== null) {
                            node.data = val;
                        }
                    }
                });
            }
        };

        if (typeof window.marketo_translations !== 'undefined') {

            // Translate form labels and options
            formElement.find('label, option, button, span, a, p, div, strong, i, u, b').each(function () {
                replaceEntries(this);
            });

            // Translate form inputs placeholders
            formElement.find('input, textarea').each(function () {
                var key = this.getAttribute('placeholder');

                if (window.marketo_translations[key]) {
                    this.setAttribute('placeholder', window.marketo_translations[key]);
                }
            });

            // Translate form messages
            var pairs = []; // array with pairs of objects - {search: 'val1', replace: 'val2'}
            var fields = formElement[0].querySelectorAll('.mktoFieldDescriptor');
            var needles = Object.keys(window.marketo_translations);
            var arrayify = getSelection.call.bind([].slice);

            needles.forEach(function (key) {
                pairs.push({
                    search: key,
                    replace: window.marketo_translations[key]
                })
            });

            arrayify(fields)
                .map(function(desc){
                    return MktoForms2.$(desc).data("mktoFieldDescriptor");
                })
                .filter(function(descJ){
                    return descJ.validationMessage !== undefined;
                })
                .forEach(function(descJ){
                    pairs.forEach(function(message){
                        descJ.validationMessage = descJ.validationMessage.replace(message.search, message.replace);
                    });
                });
        }

        MktoForms2.whenRendered(function (form) {
            var formElement = form.getFormElem();
            if(formElement.hasClass('mktoForm--conditionals')){
                formElement.find('.has-placeholder').each(function () {
                    var el = jQuery(this);
                    if (!el.find('.mktoPlaceholder').length){
                        el.removeClass('has-placeholder');
                        var item = el.find('.mktoField'),
                            parent = item.parents('.mktoFormRow'),
                            type = false;

                        if(item.is('input')){
                            if(item.attr('type') === 'text' || item.attr('type') === 'email' || item.attr('type') === 'tel') {
                                type = 'input';
                            }
                            if(item.attr('type') === 'checkbox') {
                                type = 'checkbox';
                            }
                            if(item.attr('type') === 'radio') {
                                type = 'radio';
                            }
                        }

                        if(item.is('select')){
                            type = 'select';
                        }
                        if(type){
                            parent.addClass('mktoField--'+type);
                        }
                    }
                });
            }
        });
    });
}
